import { render } from "./Loading.vue?vue&type=template&id=3c088320"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=3c088320&lang=css"
script.render = render

export default script